@import './variables.scss';

.iono-player,
.iono-player *,
.iono-player *::before,
.iono-player *::after {
    box-sizing: border-box;
}

.iono-player :focus {
    outline: none;
}

.iono-player {
    overflow: hidden;
    position: relative;
    max-height: 100%;
    font-weight: $fontWeight;
    font-size: $fontSize;
    font-family: $fontFamily;
    line-height: $lineHeight;
    color: $foreground;
    background-color: $background;
    user-select: none;
}

.iono-player audio,
.iono-player video {
    background: transparent;
}

.iono-player [hidden] {
    display: none!important;
}

.iono-player a {
    color: currentColor;
    text-decoration: none;
    cursor: pointer;
}

.iono-player-link {
    text-decoration: none;
}

.iono-icon {
    position: relative;
    display: inline-block;
    width: 1em;
    height: 1em;
    vertical-align: baseline;
    color: currentColor;
    fill: currentColor;
    pointer-events: none;
}

.iono-icon-large {
    height: 70px;
    width: 70px;
}

.iono-icon-10 {
    height: 10px;
    width: 10px;
}

.iono-icon-20 {
    height: 20px;
    width: 20px;
}

.iono-icon-32 {
    height: 32px;
    width: 32px;
}

.iono-icon-40 {
    height: 40px;
    width: 40px;
}

.iono-icon > svg {
    position: absolute;
    top: 0;
    left: 0;
    fill: inherit;
    width: 100%;
    height: 100%;
}

.iono-icon-accent {
    color: $accent;
    fill: $accent;
}

.iono-icon-text {
  font-weight: 400;
  font-size: 12px;
  letter-spacing: -0.5px;
  width: auto;
}

.iono-button,
.iono-icon-button {
    display: inline-block;
    font-weight: 400;
    font-size: $buttonFontSize;
    font-family: $fontFamily;
    line-height: 1;
    cursor: pointer;
    border: none;
    padding: 0;
    margin: 0;
    background-color: transparent;
    color: inherit;
    white-space: nowrap;
    border-radius: 2px;
    text-decoration: none;
    min-height: 30px;
}

.iono-button {
    padding: .66em 1em;
}

.iono-icon-button {}

.iono-button *,
.iono-icon-button * {
    pointer-events: none;
}

.iono-button > svg,
.iono-icon-button > svg {
    width: 1em;
    height: 1em;
    vertical-align: middle;
}

.iono-button-label {
    display: inline-block;
    font-size: $buttonLabelFontSize;
}

.iono-button-icon {
    vertical-align: middle;
}

.iono-button-small {
    padding: 4px;
    font-size: 10px;
    font-weight: 500;
    min-height: 18px;
}

.iono-button-inverse {
    background-color: $foreground;
    color: $background;
}

.iono-button-hollow {
    background-color: transparent;
    border-width: 2px;
    border-style: solid;
}

.iono-player-toggle-play .iono-button-label {
    display: none;
}

.iono-logo-image {
    max-width: 100%;
    height: auto;
}

.iono-player-logo {}

.iono-player-logo > svg {
    fill: $foreground;
    color: $accent;
    vertical-align: top;
}

.iono-position, .iono-duration {
    font-variant-numeric: tabular-nums;
}

/** QUALITY COMPONENT **/

.iono-player-quality .iono-select-options {
    top: auto;
    bottom: 0;
    right: 0;
}

.iono-player-quality .iono-select-option > * {
    pointer-events: none;
}

/** VOLUME COMPONENT **/

.iono-player-volume {
    min-height: 30px;
    position: relative;
}

.iono-player-volume .iono-player-volume-slider {
    display: none;
    position: absolute;
    width: 100%;
    bottom: 100%;
}

.iono-player-volume.iono-open .iono-player-volume-slider {
    display: block;
    height: 70px;
}

.iono-player-volume.iono-open .iono-player-toggle-mute {
    border-top-left-radius: 0;
    border-top-right-radius: 0;
}

/** SHARING COMPONENT **/

.iono-player-sharing .iono-select-options {
    top: auto;
    bottom: 0;
    left: auto;
    right: 0;
}

/** SLIDER COMPONENT **/

.iono-slider {
    min-height: 20px;
    cursor: pointer;
    position: relative;
}

.iono-slider-container {
    position: relative;
    min-height: 20px;
    height: 100%;
    z-index: 2;
}

.iono-slider-track,
.iono-slider-progress,
.iono-slider-knob {
    position: absolute;
    top: 50%;
    transform: translate(0, -50%);
}

.iono-slider-progress,
.iono-slider-knob {
    z-index: 2;
}

.iono-slider-track {
    background-color: rgba($foreground, 0.15);
    height: $sliderTrackHeight;
    width: 100%;
    border-radius: 10px;
    left: 0;
    z-index: 1;
}

.iono-slider-progress {
    background-color: $foreground;
    height: $sliderTrackHeight;
    border-radius: 10px;
    left: 0;
}

.iono-slider-knob {
    padding: 0;
    width: 12px;
    height: 12px;
    border-radius: 50px;
    border: none;
    transform: translate(-50%, -50%);
    background-color: $foreground;
}

.iono-slider-knob:after {
    position: absolute;
    content: "";
    display: none;
    width: 20px;
    height: 20px;
    background-color: inherit;
    border-radius: 50px;
    margin-left: -4px;
    margin-top: -4px;
    opacity: 0.4;
    top: 0;
    left: 0;
}

.iono-slider:hover .iono-slider-knob:after {
    display: block;
}

.iono-slider-knob.iono-theme-accent,
.iono-slider-progress.iono-theme-accent {
    background-color: $accent;
}

.iono-slider-vertical {
    min-width: 20px;
    height: 100%;
}

.iono-slider-vertical .iono-slider-container {
    min-width: 20px;
    width: 100%;
}

.iono-slider-vertical .iono-slider-track,
.iono-slider-vertical .iono-slider-progress,
.iono-slider-vertical .iono-slider-knob {
    left: 50%;
    transform: translateX(-50%);
}

.iono-slider-vertical .iono-slider-track {
    height: 100%;
    width: $sliderTrackHeight;
    top: auto;
    bottom: 0;
}

.iono-slider-vertical .iono-slider-progress {
    height: 0;
    width: $sliderTrackHeight;
    top: auto;
    bottom: 0;
}

.iono-slider-vertical .iono-slider-knob {
    top: auto;
    bottom: 0;
    transform: translate(-50%, 50%);
}

/** TIMELINE **/
.iono-timeline-buffered-progress {
    background: $accent;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    border-radius: 50px;
    z-index: 1;
    opacity: 0.5;
}

/** SELECT COMPONENT **/

.iono-select {
    position: relative;
}

.iono-select-options {
    display: none;
    position: absolute;
    top: 100%;
    list-style: none;
    margin: 0;
    padding: 4px 0;
    border-radius: 4px;
    min-width: 120px;
    background-color: $background;
    border: 2px solid $border;
    z-index: 100;
    outline: none;
}

.iono-select.iono-open .iono-select-options {
    display: block;
}

.iono-select-option {
    display: block;
    padding: 4px 8px;
    cursor: pointer;
    text-decoration: none;
    white-space: nowrap;
}

.iono-select-option.iono-selected {
    color: $selectoption-selected;
}

.iono-select-option:hover {
    background-color: $selectoption-hover;
}


/** CHAPTERS TIMELINE COMPONENT */

.iono-chapters-timeline {
    position: relative;
    height: 8px;
}

.iono-chapters-timeline-chapter {
    position: absolute;
    top: 0;
    height: 100%;
}

.iono-chapters-timeline-marker {
    position: absolute;
    top: 3px;
    width: 6px;
    height: 6px;
    border-radius: 10px;
    background-color: $border;
    opacity: 0.5;
}

.iono-chapters-timeline-marker:hover {
    opacity: 1;
}


/** WAVEFORM COMPONENT **/

.iono-waveform {
    display: block;
}


/** MARQUEE COMPONENT **/

.iono-marquee {
    white-space: nowrap;
    overflow: hidden;
}

.iono-marquee-content {
    display: inline-block;
}

.iono-marquee.iono-animated .iono-marquee-content {
    padding-left: 100%;
    animation: iono-marquee 10s linear infinite;
}

.iono-marquee.iono-marquee--pause-on-hover:hover .iono-marquee-content {
    animation-play-state: paused !important;
}

@keyframes iono-marquee {
    0% { transform: translate(0, 0); }
    100% { transform: translate(-100%, 0); }
}

/** AD IMAGE COMPONENT **/

.iono-ad {
    margin: auto;
    cursor: pointer;
}

.iono-ad .iono-ad-image {
    position: relative;
    display: block;
    margin: 0 auto;
    text-align: center;
    height: 0;
}

.iono-ad-320x50 {
    max-width: 320px;
}

.iono-ad-300x250 {
    max-width: 300px;
}

.iono-ad-320x50 .iono-ad-image {
    padding-bottom: 15.625%;
}

.iono-ad-300x250 .iono-ad-image {
    padding-bottom: 83.333%;
}

.iono-ad .iono-ad-image img {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
}

.iono-ad .iono-ad-title {
    text-align: center;
    display: block;
}


/** COVER ART **/
.iono-coverart {
    background-size: cover;
}

/** SEARCH COMPONENT **/
.iono-search {
    max-width: 400px;
    position: relative;
    z-index: 2;
}

.iono-search[data-state="open"] {
    flex-grow: 1;
}

.iono-search-box {
    z-index: 2;
}

.iono-search-results-container {
    position: absolute;
    top: -2px;
    left: -2px;
    padding: 30px 0 0px 0;
    width: 100%;
    font-size: 12px;
    line-height: 21px;
    color: $foreground;
    background: $background;
    border: 2px solid $border;
    border-radius: 4px;
    box-sizing: content-box;
}

.iono-search-results {
    border-top: 1px solid $border;
    max-height: 110px;
    overflow: hidden;
    overflow-y: auto;
    padding: 4px 0;
}

.iono-search-results:empty {
    border: 0;
    padding: 0;
}

.iono-search-input {
    outline: 0;
    border: 0;
    min-width: 0;
    padding: 4px 8px;
    border-top-left-radius: 2px;
    background: transparent;
    color: inherit;
}

.iono-search-toggle {
    outline: 0;
    min-width: 36px;
}

.iono-search[data-state="open"] .iono-search-toggle {
    border-radius: 0;
    border-top-right-radius: 2px;
}

.iono-search-result {
    padding: 4px 8px;
    cursor: pointer;
}

.iono-search-result:hover {
    background: $selectoption-hover;
}

.iono-search-result.iono-selected {
    color: $selectoption-selected;
}

.iono-search-result b {
    font-weight: 600;
}

.iono-search-results-container {
    display: none;
}

.iono-search[data-state="open"] .iono-search-results-container {
    display: block;
}

.iono-search[data-state="open"] [data-state-show]:not([data-state-show="open"]) {
  display: none;
}

.iono-search[data-state="close"] [data-state-show]:not([data-state-show="close"]) {
  display: none;
}

/** PLAYLIST COMPONENT **/
.iono-playlist-items {
    margin: 0;
    padding: 0;
}
.iono-playlist-item {
    cursor: pointer;
}

/** STICKY PLAYER **/

.iono-player-sticky {
    position: absolute;
    top: 0;
    width: 100%;
    z-index: 10;
    border-bottom: 1px solid transparent;
}

.iono-player-sticky .iono-player-sticky-toggle-play {
    padding: 0;
}

.iono-player-sticky .iono-player-sticky-timeline {
    position: absolute;
    bottom: -9px;
    left: 0;
    width: 100%;
}

.iono-player-sticky-track,
.iono-player-sticky-buffered-progress,
.iono-player-sticky-position-progress {
    border-radius: 0;
}

.iono-player-sticky .iono-player-logo {
    float: none;
    margin-top: 0;
}

/** TOOLTIPS */

.iono-tooltip {
    z-index: 10;
}

.iono-tooltip-inner {
    background: #000;
    border: 1px solid #fff;
    color: #fff;
    font-size: 12px;
    font-family: $fontFamily;
    font-weight: $fontWeight;
    line-height: 18px;
    padding: 2px 4px;
}

.iono-tooltip-arrow {
    // position: relative;
    // left: -4px;
    // width: 0;
    // height: 0;
    // border: 4px solid transparent;
    // border-bottom-color: $border;
}


/** UTILS **/

.iono-vscroller {
    overflow: hidden;
    overflow-y: auto;
}

.iono-timespan {
    min-width: 50px;
    text-align: center;
}

.iono-sr-only {
    position: absolute;
    width: 1px;
    height: 1px;
    overflow: hidden;
    border: 0;
    padding: 0;
    white-space: nowrap;
}

.iono-no-interaction {
    pointer-events: none;
}

.iono-rounded {
    border-radius: 2px;
}

.iono-float-right {
    float: right;
}

.iono-flex {
    display: flex;
    min-width: 0;
    min-height: 0;
}

.iono-flex-vertical {
    flex-direction: column;
}

.iono-flex-shrink-0 {
    flex-shrink: 0;
}

.iono-flex-grow {
    flex-grow: 1;
    max-width: 100%;
}

.iono-flex-shrink {
    flex-shrink: 1;
    min-width: 0;
}

.iono-align-items-start {
    align-items: flex-start;
}

.iono-align-items-center {
    align-items: center;
}

.iono-align-self-start {
    align-self: flex-start;
}

.iono-align-self-center {
    align-self: center;
}

.iono-justify-content-between {
    justify-content: space-between;
}

.iono-flex.iono-space-between {
    justify-content: space-between;
}

.iono-vertical-align-top {
    vertical-align: top;
}

.iono-vertical-align-middle {
    vertical-align: middle;
}

.iono-text-ellipsis {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.iono-text-small {
    font-size: 12px;
}

.iono-text-muted {
    color: $muted;
}

.iono-text-accent {
    color: $accent;
}

.iono-text-uppercase {
    text-transform: uppercase;
}

.iono-text-capitalize {
    text-transform: capitalize;
}

.iono-text-center {
    text-align: center;
}

.iono-text-left {
    text-align: left;
}

.iono-text-right {
    text-align: right;
}

.iono-padding-0 {
    padding: 0;
}

.iono-padding {
    padding: 4px;
}

.iono-padding-2 {
    padding: 8px;
}

.iono-padding-3 {
    padding: 16px;
}

.iono-padding-y-2 {
    padding-top: 8px;
    padding-bottom: 8px;
}

.iono-padding-y-3 {
    padding-top: 16px;
    padding-bottom: 16px;
}

.iono-padding-x {
    padding-left: 4px;
    padding-right: 4px;
}

.iono-padding-x-2 {
    padding-left: 8px;
    padding-right: 8px;
}

.iono-padding-x-3 {
    padding-left: 16px;
    padding-right: 16px;
}

.iono-padding-top-0 {
    padding-top: 0;
}

.iono-padding-top-2 {
    padding-top: 8px;
}

.iono-padding-top-3 {
    padding-top: 16px;
}

.iono-padding-bottom-0 {
    padding-bottom: 0;
}

.iono-padding-bottom-2 {
    padding-bottom: 8px;
}

.iono-padding-left {
    padding-left: 4px;
}

.iono-padding-left-2 {
    padding-left: 8px;
}

.iono-padding-right-2 {
    padding-right: 8px;
}

.iono-padding-right-3 {
    padding-right: 16px;
}

.iono-margin-x {
    margin-left: 4px;
    margin-right: 4px;
}

.iono-margin-x-2 {
    margin-left: 8px;
    margin-right: 8px;
}

.iono-margin-x-3 {
    margin-left: 16px;
    margin-right: 16px;
}

.iono-margin-left {
    margin-left: 4px;
}

.iono-margin-left-2 {
    margin-left: 8px;
}

.iono-margin-left-3 {
    margin-left: 16px;
}

.iono-margin-left-auto {
    margin-left: auto;
}

.iono-margin-right {
    margin-right: 4px;
}

.iono-margin-right-2 {
    margin-right: 8px;
}

.iono-margin-right-3 {
    margin-right: 16px;
}

.iono-margin-right-auto {
    margin-right: auto;
}

.iono-margin-bottom {
    margin-bottom: 4px;
}

.iono-margin-bottom-2 {
    margin-bottom: 8px;
}

.iono-margin-bottom-3 {
    margin-bottom: 16px;
}

.iono-margin-top-2 {
    margin-top: 8px;
}

.iono-margin-top-3 {
    margin-top: 16px;
}

.iono-margin-y-auto {
    margin-top: auto;
    margin-bottom: auto;
}

.iono-border {
    border: 1px solid $border;
}

.iono-border-top {
    border-top: 1px solid $border;
}

.iono-border-bottom {
    border-bottom: 1px solid $border;
}

.iono-opacity-2 {
    opacity: .2;
}

.iono-bold {
    font-weight: 600;
}

.iono-bolder {
    font-weight: 500;
}

.iono-invisible {
    opacity: 0;
}

@media (max-width:440px) {
    .iono-hidden-phone {
        display: none;
    }
}

/** THEME **/

.iono-theme-icon-accent {
    fill: $accent;
}

.iono-theme-icon-muted {
    fill: $muted;
}

.iono-theme-link {
    color: $foreground;
}

.iono-theme-link:not([nohref]):hover {
    color: darken($foreground, 20%);
}

.iono-theme-rounded {
    border-radius: 0;
}


/** ANIMATIONS **/

.iono-spin {
    animation: linear iono-spin $spinAnimationDuration infinite;
    transform-origin: 50%;
}

@keyframes iono-spin {
    0% {
        transform: rotateZ(0deg);
    }
    100% {
        transform: rotateZ(360deg);
    }
}

.iono-fade-in {
    opacity: 0;
    animation: iono-fade-in 300ms;
}

.iono-fade-out {
    opacity: 1;
    animation: iono-fade-out 300ms;
}

@keyframes iono-fade-in {
    0% {
        opacity: 0;
    }
    100% {
        opacity: 1;
    }
}

@keyframes iono-fade-out {
    0% {
        opacity: 1;
    }
    100% {
        opacity: 0;
    }
}
